import { httpClient } from "../../httpClient";

export async function postAnnouncement(payload: any): Promise<boolean> {
  try {
    const { data } = await httpClient.post<boolean>(
      `/api/v1/announcements`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function putAnnouncement(payload: any): Promise<boolean> {
  try {
    const { data } = await httpClient.put<boolean>(
      `/api/v1/announcements`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function deleteAnnouncement(id: number): Promise<boolean> {
  try {
    const { data } = await httpClient.delete<boolean>(
      `/api/v1/announcements/${id}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}
